import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_TRADEPLUS_URL;

export const addOrder = async (data) => {
  const idempotencyKey = crypto.randomUUID(); // unique per attempt

  const response = await axios.post(`${API_BASE_URL}/Orders/SaveOrder`, data, {
    headers: {
      "Idempotency-Key": idempotencyKey,
    },
  });

  return response.data;
};
